<template>
  <redesign-layout minimal>
    <div class="rd-forgot-shell">
      <section class="rd-card rd-auth-card rd-forgot-card">
        <div v-if="isChecking" class="rd-forgot-state" role="status">
          <div class="rd-forgot-state-icon is-loading">
            <span class="rd-spinner" aria-hidden="true"></span>
          </div>
          <span class="rd-kicker">Pemulihan Akun</span>
          <h1>Memeriksa Tautan</h1>
          <p class="rd-subtitle">
            Mohon tunggu, tautan pemulihan password sedang diverifikasi.
          </p>
        </div>

        <div v-else-if="invalidLink" class="rd-forgot-state">
          <div class="rd-forgot-state-icon is-danger">
            <i class="fa fa-link" aria-hidden="true"></i>
          </div>
          <span class="rd-kicker">Pemulihan Akun</span>
          <h1>Tautan Tidak Valid</h1>
          <p class="rd-subtitle">{{ invalidMessage }}</p>
          <div class="rd-forgot-actions">
            <router-link
              to="/forgotpassword"
              class="rd-button rd-button--primary rd-button--block"
            >
              Minta Tautan Baru
            </router-link>
            <router-link
              to="/login"
              class="rd-button rd-button--soft rd-button--block"
            >
              Kembali ke Login
            </router-link>
          </div>
        </div>

        <div v-else-if="passwordUpdated" class="rd-forgot-state" role="status">
          <div class="rd-forgot-state-icon is-success">
            <i class="fa fa-check" aria-hidden="true"></i>
          </div>
          <span class="rd-kicker">Password Diperbarui</span>
          <h1>Password Berhasil Diubah</h1>
          <p class="rd-subtitle">{{ successMessage }}</p>
          <p class="rd-forgot-help">Anda akan diarahkan ke halaman login.</p>
          <div class="rd-forgot-actions">
            <router-link
              to="/login"
              class="rd-button rd-button--primary rd-button--block"
            >
              Masuk Sekarang
            </router-link>
          </div>
        </div>

        <template v-else-if="verified">
          <span class="rd-kicker">Langkah 2 dari 2</span>
          <h1>Buat Password Baru</h1>
          <p class="rd-subtitle">
            Masukkan password baru dan ulangi untuk memastikan tidak ada
            kesalahan pengetikan.
          </p>

          <div v-if="verificationMessage" class="rd-alert rd-alert--success">
            <i class="fa fa-check-circle" aria-hidden="true"></i>
            <span>{{ verificationMessage }}</span>
          </div>

          <form novalidate @submit.prevent="updatePasswordForgot">
            <div class="rd-field">
              <label class="rd-label" for="rd-new-password">Password Baru</label>
              <input
                id="rd-new-password"
                v-model="fieldsPass.member_password_new"
                class="rd-input"
                :class="{ 'is-invalid': validation.password }"
                type="password"
                autocomplete="new-password"
                placeholder="Masukkan password baru"
                :disabled="isSubmitting"
                @input="clearValidation('password')"
              />
              <div v-if="validation.password" class="rd-form-error">
                {{ validation.password }}
              </div>
            </div>

            <div class="rd-field">
              <label class="rd-label" for="rd-repeat-password">
                Ulangi Password Baru
              </label>
              <input
                id="rd-repeat-password"
                v-model="fieldsPass.member_password_new_repeat"
                class="rd-input"
                :class="{ 'is-invalid': validation.passwordRepeat }"
                type="password"
                autocomplete="new-password"
                placeholder="Ulangi password baru"
                :disabled="isSubmitting"
                @input="clearValidation('passwordRepeat')"
              />
              <div v-if="validation.passwordRepeat" class="rd-form-error">
                {{ validation.passwordRepeat }}
              </div>
            </div>

            <div v-if="errorMessage" class="rd-alert" role="alert">
              <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
              <span>{{ errorMessage }}</span>
            </div>

            <button
              type="submit"
              class="rd-button rd-button--primary rd-button--block"
              :disabled="isSubmitting"
            >
              <span v-if="isSubmitting" class="rd-spinner" aria-hidden="true"></span>
              <i v-else class="fa fa-save" aria-hidden="true"></i>
              {{ isSubmitting ? "Menyimpan..." : "Simpan Password Baru" }}
            </button>

            <p class="rd-auth-switch">
              <router-link to="/login" class="rd-link">Kembali ke Login</router-link>
            </p>
            <p class="rd-auth-agent">
              Belum punya akun?
              <router-link to="/subscriptions" class="rd-link">Daftar</router-link>
            </p>
          </form>
        </template>
      </section>
    </div>
  </redesign-layout>
</template>

<script>
import RedesignLayout from "../redesign/components/RedesignLayout.vue";
import { getApiErrorMessage } from "@/utils/redesignErrors";

export default {
  name: "forgotCheck",
  components: {
    RedesignLayout
  },
  data() {
    return {
      isChecking: true,
      verified: false,
      invalidLink: false,
      invalidMessage: "",
      verificationMessage: "",
      passwordUpdated: false,
      successMessage: "",
      isSubmitting: false,
      errorMessage: "",
      validation: {
        password: "",
        passwordRepeat: ""
      },
      fields: {
        id: "",
        confirm_code: ""
      },
      fieldsPass: {
        id: "",
        confirm_code: "",
        member_password_new: "",
        member_password_new_repeat: ""
      },
      redirectTimer: null
    };
  },
  created() {
    const id = this.$route.query.id ? String(this.$route.query.id) : "";
    const code = this.$route.query.confirm_code
      ? String(this.$route.query.confirm_code)
      : "";

    if (!id || !code) {
      this.isChecking = false;
      this.invalidLink = true;
      this.invalidMessage =
        "Tautan pemulihan tidak lengkap. Silakan minta tautan pemulihan baru.";
      return;
    }

    this.fields.id = id;
    this.fields.confirm_code = code;
    this.fieldsPass.id = id;
    this.fieldsPass.confirm_code = code;
    this.checkForgot();
  },
  beforeDestroy() {
    if (this.redirectTimer) {
      clearTimeout(this.redirectTimer);
      this.redirectTimer = null;
    }
  },
  methods: {
    clearValidation(field) {
      if (Object.prototype.hasOwnProperty.call(this.validation, field)) {
        this.validation[field] = "";
      }
    },
    validatePassword() {
      if (!this.fieldsPass.member_password_new) {
        this.validation.password = "Password baru wajib diisi.";
      } else {
        this.validation.password = "";
      }
      return !this.validation.password;
    },
    validatePasswordRepeat() {
      if (!this.fieldsPass.member_password_new_repeat) {
        this.validation.passwordRepeat = "Ulangi password baru Anda.";
      } else if (
        this.fieldsPass.member_password_new !==
        this.fieldsPass.member_password_new_repeat
      ) {
        this.validation.passwordRepeat = "Konfirmasi password tidak sama.";
      } else {
        this.validation.passwordRepeat = "";
      }
      return !this.validation.passwordRepeat;
    },
    validateForm() {
      const passwordValid = this.validatePassword();
      const repeatValid = this.validatePasswordRepeat();
      return passwordValid && repeatValid;
    },
    async checkForgot() {
      this.isChecking = true;
      this.invalidLink = false;
      this.invalidMessage = "";
      try {
        const response = await this.$store.dispatch(
          "forgot/checkForgot",
          this.fields
        );
        if (!response || Number(response.status) !== 200) {
          this.invalidLink = true;
          this.invalidMessage = this.getCheckErrorMessage(response);
          return;
        }
        this.verified = true;
        this.verificationMessage =
          "Tautan pemulihan valid. Silakan buat password baru untuk akun Anda.";
      } catch (error) {
        this.invalidLink = true;
        this.invalidMessage = this.getCheckErrorMessage(error);
      } finally {
        this.isChecking = false;
      }
    },
    async updatePasswordForgot() {
      if (this.isSubmitting) {
        return;
      }
      this.errorMessage = "";
      if (!this.validateForm()) {
        return;
      }

      this.isSubmitting = true;
      try {
        const response = await this.$store.dispatch(
          "forgot/updatePasswordForgot",
          this.fieldsPass
        );
        if (!response || Number(response.status) !== 200) {
          if (this.isInvalidLinkError(response)) {
            this.showInvalidLink();
          } else {
            this.errorMessage = this.getUpdateErrorMessage(response);
          }
          return;
        }

        const apiMessage =
          response.msg && String(response.msg).trim()
            ? String(response.msg).trim()
            : "";
        this.passwordUpdated = true;
        this.successMessage = this.isGenericSuccessMessage(apiMessage)
          ? "Password akun Anda berhasil diubah. Silakan masuk menggunakan password baru."
          : apiMessage;
        this.redirectTimer = setTimeout(() => {
          this.$router.push("/login");
        }, 3000);
      } catch (error) {
        if (this.isInvalidLinkError(error)) {
          this.showInvalidLink();
        } else {
          this.errorMessage = this.getUpdateErrorMessage(error);
        }
      } finally {
        this.isSubmitting = false;
      }
    },
    showInvalidLink() {
      this.passwordUpdated = false;
      this.verified = false;
      this.invalidLink = true;
      this.invalidMessage =
        "Tautan pemulihan sudah tidak berlaku. Silakan minta tautan pemulihan baru.";
    },
    isGenericSuccessMessage(message) {
      return !message || /^(ok|success|sukses)\.?$/i.test(message);
    },
    getRawErrorMessage(error) {
      if (error && error.response && error.response.data) {
        return String(error.response.data.msg || "");
      }
      if (error && typeof error.msg === "string") {
        return error.msg;
      }
      if (error && typeof error.message === "string") {
        return error.message;
      }
      return "";
    },
    isInvalidLinkError(error) {
      const status =
        error && error.response ? Number(error.response.status) : 0;
      if (status === 401 || status === 403 || status === 404) {
        return true;
      }
      if (
        Number(error && error.status) === 401 ||
        Number(error && error.status) === 403 ||
        Number(error && error.status) === 404
      ) {
        return true;
      }
      const message = this.getRawErrorMessage(error).toLowerCase();
      return (
        (status === 406 || Number(error && error.status) === 406) &&
        /confirm|forgot|expired|not found|code/.test(message)
      );
    },
    getCheckErrorMessage(error) {
      const status =
        error && error.response ? Number(error.response.status) : 0;
      if (
        status === 401 ||
        status === 403 ||
        status === 404 ||
        status === 406
      ) {
        return "Tautan pemulihan tidak valid atau sudah kedaluwarsa. Silakan minta tautan baru.";
      }
      if (status >= 500) {
        return "Layanan pemulihan sedang tidak tersedia. Silakan coba lagi.";
      }
      return getApiErrorMessage(
        error,
        "Tautan pemulihan tidak valid atau sudah kedaluwarsa. Silakan minta tautan baru."
      );
    },
    getUpdateErrorMessage(error) {
      const status =
        error && error.response ? Number(error.response.status) : 0;
      if (status === 401 || status === 403 || status === 404) {
        return "Tautan pemulihan sudah tidak berlaku. Silakan minta tautan pemulihan baru.";
      }
      if (status >= 500) {
        return "Password belum berhasil diubah. Silakan coba lagi.";
      }
      return getApiErrorMessage(
        error,
        "Password belum berhasil diubah. Periksa data Anda lalu coba lagi."
      );
    }
  }
};
</script>

<style scoped>
.rd-forgot-shell {
  width: 100%;
  max-width: 520px;
  margin: 0 auto;
}

.rd-forgot-card {
  padding: 38px;
}

.rd-forgot-card .rd-alert {
  margin-bottom: 14px;
}

.rd-forgot-state {
  text-align: center;
}

.rd-forgot-state .rd-kicker {
  justify-content: center;
}

.rd-forgot-state .rd-subtitle {
  margin-bottom: 22px;
}

.rd-forgot-state-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  margin-bottom: 14px;
  border-radius: 50%;
  font-size: 22px;
}

.rd-forgot-state-icon.is-success {
  background: #ecfdf3;
  color: #15803d;
}

.rd-forgot-state-icon.is-danger {
  background: #fef2f2;
  color: #dc2626;
}

.rd-forgot-state-icon.is-loading {
  background: #fff3e6;
  color: #fe9b44;
}

.rd-forgot-state-icon .rd-spinner {
  width: 18px;
  height: 18px;
  border-width: 2px;
}

.rd-forgot-actions {
  display: grid;
  gap: 9px;
  margin-top: 4px;
}

.rd-forgot-help {
  margin: 13px 0 0;
  color: #94a3b8;
  font-size: 11px;
  line-height: 1.6;
  text-align: center;
}

@media (max-width: 575.98px) {
  .rd-forgot-card {
    padding: 24px 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/forgot/check.vue